import { TreatmentPlanTableColumnNames } from "../enums/treatment-plan-table-column-names.enum";

export const TREATMENT_PLAN_TABLE_COLUMNS: TreatmentPlanTableColumnNames[] = [
  TreatmentPlanTableColumnNames.Tooth, 
  TreatmentPlanTableColumnNames.TreatmentPlan, 
  TreatmentPlanTableColumnNames.CostEstimates, 
  TreatmentPlanTableColumnNames.PriorityDesc
];
